import { DateTime } from 'luxon'
import performance from 'performance-polyfill'

class Perf {

  constructor(enabled) {
    this.enabled = enabled === true
  }

  start(action) {
    if (!this.enabled) {
      return
    }
    const name = `${action}:start`
    if (performance.mark !== undefined) {
      performance.mark(name)
    }
  }

  stop(action, desc) {
    if (!this.enabled) {
      return
    }
    const startMark = `${action}:start`
    const endMark = `${action}:stop`
    if (performance.mark !== undefined) {
      performance.mark(endMark)
    }
    if (performance.measure !== undefined) {
      try {
        performance.measure(action, startMark, endMark)
      } catch(err) {
        // start marker not set or markers out of sequence, drop silently
      }
    }
    if (performance.getEntriesByName !== undefined) {
      const measure = performance.getEntriesByName(action, 'measure')
      if (measure) {
        this.log(measure, desc)
      }
      performance.clearMarks(startMark)
      performance.clearMarks(endMark)
      performance.clearMeasures(action)
    }
    return null
  }

  measureNow(action, desc) {
    if (!this.enabled) {
      return
    }
    if (performance.measure !== undefined) {
      performance.measure(action)
    }
    if (performance.getEntriesByName !== undefined) {
      const measure = performance.getEntriesByName(action, 'measure')
      if (measure) {
        this.log(measure, desc)
      }
      performance.clearMeasures(action)
    }
    return null
  }

  log(performanceMeasures, desc) {
    if (!this.enabled) {
      return
    }
    if (performanceMeasures.length > 0) {
      performanceMeasures.forEach(performanceMeasure => {
        const descFormatted = desc ? ` - ${desc.toString()}` : ''
        console.log(`[${DateTime.local().toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}][${this.formatDuration(performanceMeasure.duration)}] ${performanceMeasure.name}${descFormatted}`)  
      })
    }
  }

  formatDuration(ts) {
    const newTs = ts / 1000
    let formatted = `${parseFloat(Math.round(newTs * 1000) / 1000).toFixed(3)} sec`;
    if (formatted.length < 11) {
      formatted = ' '.repeat(11 - formatted.length) + formatted
    }
    return formatted
  }
}

export default new Perf(typeof window.TLK_PERFORMANCE !== 'undefined' && window.TLK_PERFORMANCE === true)
